export default "__VITE_ASSET__CGetwXY2__"